/* =========================================== */
/*      TW merge config for design system      */
/*         (!!! Don't edit this file)          */
/* Generated from Parich-gen-ai-tokens.json    */
/* =========================================== */

export default {
  cacheSize: 1000,
  extend: {
    theme: {
      color: [
        'secondary-50',
        'secondary-100',
        'secondary-200',
        'secondary-300',
        'secondary-400',
        'secondary-500',
        'secondary-600',
        'secondary-700',
        'secondary-800',
        'secondary-900',
        'secondary-950',
        'secondary-a50',
        'secondary-a40',
        'secondary-a30',
        'secondary-a20',
        'secondary-a10',
        'neutral-50',
        'neutral-100',
        'neutral-200',
        'neutral-300',
        'neutral-400',
        'neutral-500',
        'neutral-600',
        'neutral-700',
        'neutral-800',
        'neutral-900',
        'neutral-950',
        'neutral-a50',
        'neutral-a40',
        'neutral-a30',
        'neutral-a20',
        'neutral-a10',
        'lime-50',
        'lime-100',
        'lime-200',
        'lime-300',
        'lime-400',
        'lime-500',
        'lime-600',
        'lime-700',
        'lime-800',
        'lime-900',
        'lime-950',
        'lime-a50',
        'lime-a40',
        'lime-a30',
        'lime-a20',
        'lime-a10',
        'green-50',
        'green-100',
        'green-200',
        'green-300',
        'green-400',
        'green-500',
        'green-600',
        'green-700',
        'green-800',
        'green-900',
        'green-950',
        'green-a50',
        'green-a40',
        'green-a30',
        'green-a20',
        'green-a10',
        'cyan-50',
        'cyan-100',
        'cyan-200',
        'cyan-300',
        'cyan-400',
        'cyan-500',
        'cyan-600',
        'cyan-700',
        'cyan-800',
        'cyan-900',
        'cyan-950',
        'cyan-a50',
        'cyan-a40',
        'cyan-a30',
        'cyan-a20',
        'cyan-a10',
        'blue-50',
        'blue-100',
        'blue-200',
        'blue-300',
        'blue-400',
        'blue-500',
        'blue-600',
        'blue-700',
        'blue-800',
        'blue-900',
        'blue-950',
        'blue-a50',
        'blue-a40',
        'blue-a30',
        'blue-a20',
        'blue-a10',
        'indigo-50',
        'indigo-100',
        'indigo-200',
        'indigo-300',
        'indigo-400',
        'indigo-500',
        'indigo-600',
        'indigo-700',
        'indigo-800',
        'indigo-900',
        'indigo-950',
        'indigo-a50',
        'indigo-a40',
        'indigo-a30',
        'indigo-a20',
        'indigo-a10',
        'purple-50',
        'purple-100',
        'purple-200',
        'purple-300',
        'purple-400',
        'purple-500',
        'purple-600',
        'purple-700',
        'purple-800',
        'purple-900',
        'purple-950',
        'purple-a50',
        'purple-a40',
        'purple-a30',
        'purple-a20',
        'purple-a10',
        'fuchsia-50',
        'fuchsia-100',
        'fuchsia-200',
        'fuchsia-300',
        'fuchsia-400',
        'fuchsia-500',
        'fuchsia-600',
        'fuchsia-700',
        'fuchsia-800',
        'fuchsia-900',
        'fuchsia-950',
        'fuchsia-a50',
        'fuchsia-a40',
        'fuchsia-a30',
        'fuchsia-a20',
        'fuchsia-a10',
        'pink-50',
        'pink-100',
        'pink-200',
        'pink-300',
        'pink-400',
        'pink-500',
        'pink-600',
        'pink-700',
        'pink-800',
        'pink-900',
        'pink-950',
        'pink-a50',
        'pink-a40',
        'pink-a30',
        'pink-a20',
        'pink-a10',
        'red-50',
        'red-100',
        'red-200',
        'red-300',
        'red-400',
        'red-500',
        'red-600',
        'red-700',
        'red-800',
        'red-900',
        'red-950',
        'red-a50',
        'red-a40',
        'red-a30',
        'red-a20',
        'red-a10',
        'primary-50',
        'primary-100',
        'primary-200',
        'primary-300',
        'primary-400',
        'primary-500',
        'primary-600',
        'primary-700',
        'primary-800',
        'primary-900',
        'primary-950',
        'primary-a50',
        'primary-a40',
        'primary-a30',
        'primary-a20',
        'primary-a10',
        'orange-50',
        'orange-100',
        'orange-200',
        'orange-300',
        'orange-400',
        'orange-500',
        'orange-600',
        'orange-700',
        'orange-800',
        'orange-900',
        'orange-950',
        'orange-a50',
        'orange-a40',
        'orange-a30',
        'orange-a20',
        'orange-a10',
        'amber-50',
        'amber-100',
        'amber-200',
        'amber-300',
        'amber-400',
        'amber-500',
        'amber-600',
        'amber-700',
        'amber-800',
        'amber-900',
        'amber-950',
        'amber-a50',
        'amber-a40',
        'amber-a30',
        'amber-a20',
        'amber-a10',
        'yellow-50',
        'yellow-100',
        'yellow-200',
        'yellow-300',
        'yellow-400',
        'yellow-500',
        'yellow-600',
        'yellow-700',
        'yellow-800',
        'yellow-900',
        'yellow-950',
        'yellow-a50',
        'yellow-a40',
        'yellow-a30',
        'yellow-a20',
        'yellow-a10',
        'pure-white',
        'pure-black',
        'cyber-yellow-50',
        'cyber-yellow-100',
        'cyber-yellow-200',
        'cyber-yellow-300',
        'cyber-yellow-400',
        'cyber-yellow-500',
        'cyber-yellow-600',
        'cyber-yellow-700',
        'cyber-yellow-800',
        'cyber-yellow-900',
        'cyber-yellow-950',
        'cyber-yellow-a50',
        'cyber-yellow-a40',
        'cyber-yellow-a30',
        'cyber-yellow-a20',
        'cyber-yellow-a10',
        'main-surface-lv-00',
        'main-surface-lv-01',
        'main-surface-lv-02',
        'main-surface-lv-03-hover',
        'main-surface-invert',
        'main-surface-lv-02-dim',
        'main-surface-lv-03',
        'main-elevation-lv01',
        'main-elevation-lv02',
        'main-elevation-lv03',
        'main-text-lv01',
        'main-text-lv02',
        'main-text-lv03',
        'main-text-inverse',
        'main-text-error',
        'main-text-success',
        'main-text-warning',
        'main-text-display',
        'main-text-info',
        'main-icon-lv01',
        'main-icon-lv02',
        'main-icon-lv03',
        'main-icon-display',
        'main-icon-inverse',
        'main-icon-error',
        'main-icon-success',
        'main-icon-warning',
        'main-icon-info',
        'main-border-lv01',
        'main-border-lv02',
        'main-border-lv03',
        'main-border-inverse',
        'main-border-display',
        'main-border-success',
        'main-border-error',
        'main-visual-secondarylv02',
        'main-visual-secondarylv03',
        'main-visual-secondarylv01',
        'main-visual-white',
        'main-visual-black',
        'main-visual-greenlv01',
        'main-visual-greenlv02',
        'main-visual-greenlv03',
        'main-visual-orangelv01',
        'main-visual-orangelv02',
        'main-visual-orange-lv03',
        'main-visual-primarylv1',
        'main-visual-primarylv2',
        'main-visual-primarylv3',
        'main-visual-cyber-yellowlv01',
        'main-visual-cyber-yellowlv02',
        'main-visual-cyber-yellowlv03',
        'main-visual-indigolv01',
        'main-visual-indigolv02',
        'main-visual-indigolv03',
        'main-support-surface-secondary',
        'main-support-surface-neutral',
        'main-support-surface-lime',
        'main-support-surface-green',
        'main-support-surface-cyan',
        'main-support-surface-blue',
        'main-support-surface-indigo',
        'main-support-surface-purple',
        'main-support-surface-fuchsia',
        'main-support-surface-pink',
        'main-support-surface-red',
        'main-support-surface-primary',
        'main-support-surface-orange',
        'main-support-surface-amber',
        'main-support-surface-yellow',
        'main-support-surface-cyber-yellow',
        'main-support-on-surface-on-secondary',
        'main-support-on-surface-on-neutral',
        'main-support-on-surface-on-lime',
        'main-support-on-surface-on-green',
        'main-support-on-surface-on-cyan',
        'main-support-on-surface-on-blue',
        'main-support-on-surface-on-indigo',
        'main-support-on-surface-on-purple',
        'main-support-on-surface-on-fuchsia',
        'main-support-on-surface-on-pink',
        'main-support-on-surface-on-rose',
        'main-support-on-surface-on-primary',
        'main-support-on-surface-on-orange',
        'main-support-on-surface-on-amber',
        'main-support-on-surface-on-yellow',
        'main-support-on-surface-on-cyber-yellow',
        'main-multiply-lv-01',
        'creation-primary-solid-surface-default',
        'creation-primary-solid-surface-focused',
        'creation-primary-solid-surface-hover',
        'creation-primary-solid-surface-pressed',
        'creation-primary-solid-surface-disable',
        'creation-primary-solid-on-surface-default',
        'creation-primary-solid-on-surface-focused',
        'creation-primary-solid-on-surface-hover',
        'creation-primary-solid-on-surface-pressed',
        'creation-primary-solid-on-surface-disable',
        'creation-primary-container-surface-default',
        'creation-primary-container-surface-hover',
        'creation-primary-container-surface-focused',
        'creation-primary-container-surface-pressed',
        'creation-primary-container-surface-disable',
        'creation-primary-container-on-surface-default',
        'creation-primary-container-on-surface-hover',
        'creation-primary-container-on-surface-focused',
        'creation-primary-container-on-surface-pressed',
        'creation-primary-container-on-surface-disable',
        'creation-secondary-solid-surface-default',
        'creation-secondary-solid-surface-hover',
        'creation-secondary-solid-surface-focused',
        'creation-secondary-solid-surface-pressed',
        'creation-secondary-solid-surface-disable',
        'creation-secondary-solid-on-surface-default',
        'creation-secondary-solid-on-surface-hover',
        'creation-secondary-solid-on-surface-focused',
        'creation-secondary-solid-on-surface-pressed',
        'creation-secondary-solid-on-surface-disable',
        'creation-secondary-container-surface-default',
        'creation-secondary-container-surface-hover',
        'creation-secondary-container-surface-focused',
        'creation-secondary-container-surface-pressed',
        'creation-secondary-container-surface-disable',
        'creation-secondary-container-on-surface-default',
        'creation-secondary-container-on-surface-hover',
        'creation-secondary-container-on-surface-focused',
        'creation-secondary-container-on-surface-pressed',
        'creation-secondary-container-on-surface-disable',
        'creation-success-solid-surface-default',
        'creation-success-solid-surface-hover',
        'creation-success-solid-surface-focused',
        'creation-success-solid-surface-pressed',
        'creation-success-solid-surface-disable',
        'creation-success-solid-on-surface-default',
        'creation-success-solid-on-surface-hover',
        'creation-success-solid-on-surface-focused',
        'creation-success-solid-on-surface-pressed',
        'creation-success-solid-on-surface-disable',
        'creation-success-container-surface-default',
        'creation-success-container-surface-hover',
        'creation-success-container-surface-focused',
        'creation-success-container-surface-pressed',
        'creation-success-container-surface-disable',
        'creation-success-container-on-surface-default',
        'creation-success-container-on-surface-hover',
        'creation-success-container-on-surface-focused',
        'creation-success-container-on-surface-pressed',
        'creation-success-container-on-surface-disable',
        'creation-warning-solid-surface-default',
        'creation-warning-solid-surface-hover',
        'creation-warning-solid-surface-focused',
        'creation-warning-solid-surface-pressed',
        'creation-warning-solid-surface-disable',
        'creation-warning-solid-on-surface-default',
        'creation-warning-solid-on-surface-hover',
        'creation-warning-solid-on-surface-focused',
        'creation-warning-solid-on-surface-pressed',
        'creation-warning-solid-on-surface-disable',
        'creation-warning-container-surface-default',
        'creation-warning-container-surface-hover',
        'creation-warning-container-surface-focused',
        'creation-warning-container-surface-pressed',
        'creation-warning-container-surface-disable',
        'creation-warning-container-on-surface-default',
        'creation-warning-container-on-surface-hover',
        'creation-warning-container-on-surface-focused',
        'creation-warning-container-on-surface-pressed',
        'creation-warning-container-on-surface-disable',
        'creation-error-solid-surface-default',
        'creation-error-solid-surface-hover',
        'creation-error-solid-surface-focused',
        'creation-error-solid-surface-pressed',
        'creation-error-solid-surface-disable',
        'creation-error-solid-on-surface-default',
        'creation-error-solid-on-surface-hover',
        'creation-error-solid-on-surface-focused',
        'creation-error-solid-on-surface-pressed',
        'creation-error-solid-on-surface-disable',
        'creation-error-container-surface-default',
        'creation-error-container-surface-hover',
        'creation-error-container-surface-focused',
        'creation-error-container-surface-pressed',
        'creation-error-container-surface-disable',
        'creation-error-container-on-surface-default',
        'creation-error-container-on-surface-hover',
        'creation-error-container-on-surface-focused',
        'creation-error-container-on-surface-pressed',
        'creation-error-container-on-surface-disable',
        'creation-info-solid-surface-default',
        'creation-info-solid-surface-hover',
        'creation-info-solid-surface-focused',
        'creation-info-solid-surface-pressed',
        'creation-info-solid-surface-disable',
        'creation-info-solid-on-surface-default',
        'creation-info-solid-on-surface-hover',
        'creation-info-solid-on-surface-focused',
        'creation-info-solid-on-surface-pressed',
        'creation-info-solid-on-surface-disable',
        'creation-info-container-surface-default',
        'creation-info-container-surface-hover',
        'creation-info-container-surface-focused',
        'creation-info-container-surface-pressed',
        'creation-info-container-surface-disable',
        'creation-info-container-on-surface-default',
        'creation-info-container-on-surface-hover',
        'creation-info-container-on-surface-focused',
        'creation-info-container-on-surface-pressed',
        'creation-info-container-on-surface-disable',
        'creation-neutral-solid-surface-default',
        'creation-neutral-solid-surface-hover',
        'creation-neutral-solid-surface-focused',
        'creation-neutral-solid-surface-pressed',
        'creation-neutral-solid-surface-disable',
        'creation-neutral-solid-on-surface-default',
        'creation-neutral-solid-on-surface-hover',
        'creation-neutral-solid-on-surface-focused',
        'creation-neutral-solid-on-surface-pressed',
        'creation-neutral-solid-on-surface-disable',
        'creation-neutral-container-surface-default',
        'creation-neutral-container-surface-hover',
        'creation-neutral-container-surface-focused',
        'creation-neutral-container-surface-pressed',
        'creation-neutral-container-surface-disable',
        'creation-neutral-container-on-surface-default',
        'creation-neutral-container-on-surface-hover',
        'creation-neutral-container-on-surface-focused',
        'creation-neutral-container-on-surface-pressed',
        'creation-neutral-container-on-surface-disable',
        'creation-placeholder-text-default',
        'creation-placeholder-text-hover',
        'creation-placeholder-text-focused',
        'creation-placeholder-text-pressed',
        'creation-placeholder-text-disable',
        'creation-placeholder-text-typing',
        'creation-placeholder-text-disable-filled',
        'creation-placeholder-text-filled',
        'creation-placeholder-icon-default',
        'creation-placeholder-icon-hover',
        'creation-placeholder-icon-focused',
        'creation-placeholder-icon-pressed',
        'creation-placeholder-icon-filled',
        'creation-placeholder-icon-disable',
        'creation-placeholder-icon-disable-filled',
      ],
      text: [
        'ui-header-h1',
        'ui-header-h2',
        'ui-header-h3',
        'ui-header-h4',
        'ui-title-t1',
        'ui-title-t2',
        'ui-title-t3',
        'ui-title-t4',
        'ui-body-b1',
        'ui-body-b2',
        'ui-caption-c1',
        'ui-caption-c2',
        'ui-label-l1',
        'ui-label-l2',
        'comp-button-bt1',
        'comp-button-bt2',
        'comp-input-ip1',
        'comp-input-ip2',
        'comp-text-link-tl1',
        'comp-text-link-tl2',
      ],
      leading: [
        'ui-header-h1',
        'ui-header-h2',
        'ui-header-h3',
        'ui-header-h4',
        'ui-title-t1',
        'ui-title-t2',
        'ui-title-t3',
        'ui-title-t4',
        'ui-body-b1',
        'ui-body-b2',
        'ui-caption-c1',
        'ui-caption-c2',
        'ui-label-l1',
        'ui-label-l2',
        'comp-button-bt1',
        'comp-button-bt2',
        'comp-input-ip1',
        'comp-input-ip2',
        'comp-text-link-tl1',
        'comp-text-link-tl2',
      ],
      font: ['bai-jamjuree'],
      'font-weight': ['semibold', 'medium', 'regular'],
      blur: ['100'],
      radius: ['100', '200', '300', '400', '600', '800', 'round'],
    },
    classGroups: {
      'border-width': [{ border: ['border', 'focus-ring'] }],
      size: [{ size: [] }],
    },
  },
}
